// extracted by mini-css-extract-plugin
module.exports = {"comp":"Banner_comp__I0HA4","banner-tips-icon":"Banner_banner-tips-icon__1PaPq"};